import type { TableColumn } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { TableMergedState } from 'components/Table/model/TableModel';
import { selectAllColumns } from 'components/Table/model/selectors/selectAllColumns';
import { createSelector } from 'reselect';
import { indexBy } from 'utils/object/indexBy';
import { createScopedSelector } from 'utils/react/scopedSelector';

export type ColumnsByKey = Record<string, TableColumn<any>>;

export const selectColumnsByKey: (s: TableMergedState) => ColumnsByKey =
  createScopedSelector(() =>
    createSelector(selectAllColumns, indexBy(prop('key'))),
  );
